import React from 'react';
import { Route,IndexRouter } from 'react-router-dom';
// import asyncComponent from "./asyncComponent.js";

// const Page=asyncComponent(() => import('pages/usercenter_home/Home.jsx'))

const GetRouter = route => {
  let {path,exact,routes,...optionProps} = route
  return (

    <div>
      {/* <IndexRouter path='/' component={Page}/> */}
      <Route
      path={route.path}
      exact={route.exact}
      render={props => (
        <route.component {...props} routes={route.routes} {...optionProps} />
      )}
    />
    </div>
  )
};
export default GetRouter;
